import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import LeafletMap from './src/components/LeafletMap.jsx';

Drupal.behaviors.trpLeafletMap = {
  attach(context, settings) {
    const baseApiUrl = settings.base_url || '';
    const maps = context.querySelectorAll('[data-leaflet-map]');

    maps.forEach((map) => {
      const mapId = map.getAttribute('data-leaflet-map');
      const blockHeading = map.getAttribute('data-heading') || '';
      const root = createRoot(map);

      root.render(<LeafletMap mapId={mapId} baseApiUrl={baseApiUrl} blockHeading={blockHeading} />);
    });
  },
};
